export const PromotionsFilters = Object.freeze({
  APPS: 'APPS',
  HOSTING: 'HOSTING',
  ACTIVE: 'ACTIVE'
});